(function () {
	'use strict';

	angular
		.module('franchiser.components')
		.controller('CompanyEconomicGroupsFranchiserListController', CompanyEconomicGroupsFranchiserListController)

	/** @ngInject */
	function CompanyEconomicGroupsFranchiserListController(UtilHelper, CompanyEconomicGroupService, LoadingHelper, sweetAlert) {
		const vm = this;

		let isTableSearch = false;
		let forcePaginationReset = false;

		vm.isSearchDisabled = () => {
			if (vm.selectedSearchField && vm.searchText)
				return false;

			return true;
		}

		vm.isClearDisabled = () => {
			if (isTableSearch)
				return false;

			if (vm.selectedSearchField || vm.searchText)
				return false;

			return true;
		}

		vm.doSearch = (event, isFromButton) => {
			if (!vm.isSearchDisabled() && (event && event.keyCode == 13) || isFromButton) {
				forcePaginationReset = true;

				vm.tableCallServer();
			}
		}

		vm.clearSearch = () => {
			vm.selectedSearchField = null;
			vm.searchText = null;

			if (isTableSearch)
				vm.tableCallServer();

			isTableSearch = false;
		}

		vm.tableCallServer = (tableState, stCtrl) => {
			if (!vm.stCtrl && stCtrl)
				vm.stCtrl = stCtrl;

			if (!tableState && vm.stCtrl) {
				vm.stCtrl.pipe();
				return;
			}

			vm.isLoading = true;

			if (forcePaginationReset) {
				tableState.pagination.start = 0;
				forcePaginationReset = false;
			}

			const pagination = tableState.pagination;
			const start = pagination.start || 0;
			const number = pagination.number || 10;

			getCompanyEconomicGroups(start, number, tableState);
		}

		vm.openMigrationModal = () => {
			vm.companyEconomicGroupsOrigin = null;
			vm.companyEconomicGroupsDestination = null;

			$('#company-status-migration').appendTo('body').modal('show');

			LoadingHelper.startLoading('.modal-loader');

			CompanyEconomicGroupService
				.getAll()
				.then(success => {
					vm.migrationCompanyStatus = success.Registers;
					LoadingHelper.stopLoading('.modal-loader');
				}, error => {
					vm.migrationCompanyStatus = null;

					UtilHelper.errorCallback(error);
					LoadingHelper.stopLoading('.modal-loader');
				})
		}

		vm.closeMigrationModal = () => {
			$('#company-status-migration').modal('hide');
		}

		init();

		function getCompanyEconomicGroups(skip, perPage, tableState) {
			let parameters = prepareParameters(skip, perPage, tableState);
			console.log('parameters: ', parameters);

			CompanyEconomicGroupService
				.getByParameters(parameters)
				.then(success => {
					vm.companyEconomicGroups = success.Registers;
					tableState.pagination.numberOfPages = success.NumberOfPages;

					vm.isLoading = false;
				}, error => {
					vm.companyEconomicGroups = null;
					vm.isLoading = false;
					UtilHelper.errorCallback(error);
				})
		}

		function prepareParameters(skip, perPage, tableState) {
			let params = {
				Skip: skip,
				PerPage: perPage,
				OrderBy: 'Id',
				OrderDescending: false
			}

			if (vm.selectedSearchField && vm.searchText)
				isTableSearch = true;

			if (tableState && tableState.sort.predicate) {
				params.OrderBy = tableState.sort.predicate;
				params.OrderDescending = tableState.sort.reverse;
			}

			if (vm.selectedSearchField && vm.searchText)
				params[vm.selectedSearchField.Value] = vm.searchText;

			return params;
		}

		function init() {
			vm.selectedSearchField;
			vm.searchText;
			vm.isLoading = true;

			vm.searchFields = [{
				Value: 'Title',
				Description: 'Nome'
			}];
		}
	}
}());